export default {
  sdkBridgeScriptURL: 'https://x.klarnacdn.net/mobile-sdk/mobile-js-snippet/v1/app.min.js'
}
